import { create } from 'zustand';

export const useSpacesContactsSaveModalStore = create<{ isOpen: boolean }>(
  () => ({ isOpen: false })
);

export const setSpacesContactsSaveModalOpen = (isOpen: boolean) =>
  useSpacesContactsSaveModalStore.setState({ isOpen });
